import { all, takeLatest, put, call } from 'redux-saga/effects';
import { isApiError, request } from '../../../xhr';
import { fetchCount, fetchCountFailure, fetchCountSuccess } from './actions';
function* handleFetchCount() {
    const response = yield call(request, {
        url: '/dachat/countunread'
    });
    if (!response || isApiError(response)) {
        yield put(fetchCountFailure());
        return;
    }
    yield put(fetchCountSuccess(response.count));
}
export function* unreadChatsSaga() {
    yield all([
        takeLatest(fetchCount, handleFetchCount)
    ]);
}
